import React from "react";

/* webpackChunkName: "ClientCompaniesDesktop" */
const ClientCompaniesModule = React.lazy(() => import(`./ui/ClientCompanies`));

export const ClientCompaniesPage = () => {
  return <ClientCompaniesModule />;
};
